import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';
import { BolsasFinanciamentoComponent } from './bolsas-financiamento.component';

@NgModule({
  imports: [ CommonModule, SharedModule ],
  declarations: [ BolsasFinanciamentoComponent ],
  exports: [],
})
export class BolsasFinanciamentoModule { }
